interface SkipLinkProps {
  targetId: string
}

export function SkipLink({ targetId }: SkipLinkProps) {
  return (
    <a
      href={`#${targetId}`}
      className="skip-link"
    >
      Ir al contenido principal
    </a>
  )
}
